var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.wrapper, _vm.wrapperMode && _vm.$style.wrapperMode, _vm.wrapperOpacity && _vm.$style.wrapperOpacity]},[(_vm.active)?_c('l-popupMessage',{attrs:{"items":_vm.popups},on:{"click":_vm.nextStep}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }